<template>
    <div>
        <b-card title="Admin" style="max-width: 30em; margin:auto" class="mb-2">
            <div>
                <div>
                    <p>Upload data</p>
                    <div>
                        <label for="password" style="margin-left:12px">Password</label>
                        <b-form-input id="password" style="width:80%; margin-left:12px" class="font-KiaSignatureBold" v-model="password" type="password"></b-form-input>
                    </div>
                    <div>
                        <input type="file" class="btn" @change="previewFiles" />
                    </div>
                    <div>
                        <input type="button" style="margin-left: 13px" v-on:click="submitFile()" value="Submit">
                    </div>
                    <div>
                        {{ status }}
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'main-component',
    data() {
        return {
            file: '',
            status: '',
            password: ''
        }
    },
    methods: {
        async submitFile() {
            if (!this.file) {
                this.status = "Please select file";
                return;
            }

            let formData = new FormData();
            formData.append('password', this.password);
            formData.append('dns', window.dns);
            formData.append('file', this.file);
            let url = `${window.baseUrl}api/Data`;
            let postConfig = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            let response = await this.axios.post(url, formData, postConfig);
            this.status = response.data;
        },
        previewFiles(event) {
            this.file = event.target.files[0];
        }
    }
}
</script>

<style scoped>

</style>
